import React, { useState, useEffect, useReducer } from 'react';
import { observer } from 'mobx-react';
import { action, observable, toJS } from 'mobx';
import Dropzone from 'react-dropzone';
import { withRouter } from 'react-router-dom';

import store from 'root/admin/store';
import { Form, Button, Icon, Field, Loader, Popup } from '@smartplatform/ui';

import './styles.scss';

import Compress from 'compress.js';

const compress = new Compress();

const setImgName = 'setImgName';
const getImages = 'getImages';
const finishUpload = 'finishUpload';
const setCurrentImage = 'setCurrentImage';
const onImgCLick = 'onImgCLick';
const updateImg = 'updateImg';

const state = {
	images: '',
	currentImage: '',
	currentImgName: '',
	editImg: false,
	thumbnail: false,
};
function reducer(state, action) {
	switch (action.type) {
		case getImages:
			return { ...state, images: action.images };
		case setCurrentImage:
			return { ...state, currentImage: action.image, thumbnail: action.thumbnail };
		case setImgName:
			return { ...state, currentImgName: action.name };
		case finishUpload:
			return { images: action.images, currentImage: '', currentImgName: '', editImg: false };
		case onImgCLick:
			return { ...state, currentImage: action.image, currentImgName: action.name, editImg: action.editImg };
		case updateImg:
			return { ...state, images: action.images };
		default:
			return state;
	}
}

//TODO: Измененить название кнопок при редактировании. Загрузка миниатюы картинок
export const Images = ({ record, property = 'images' }) => {
	const [{ images, currentImage, currentImgName, editImg, thumbnail }, dispatch] = useReducer(reducer, state);

	useEffect(() => {
		init();
	}, []);

	const init = async newImgs => {
		if (!record.id) {
			return;
		}

		if (newImgs) {
			dispatch({ type: getImages, images: newImgs });
			return;
		}

		const records = await record[property]();
		const images = [];
		await records.forEach(image => {
			const { id, name, filename } = image;
			const fileImage = image.downloadFile('filename');
			const thumbnail = image.downloadFile('thumbnail');
			images.push({ id, name, fileImage, thumbnail, filename });
		});
		dispatch({ type: getImages, images });
	};

	const handleEnd = async (error, result, attachment, newImgs) => {
		if (error) {
			console.error('error uploading file', error);
		} else {
			console.log('file uploaded', attachment.filename);

			dispatch({ type: finishUpload, images });
			init(newImgs);
		}
	};

	const imageUploader = async () => {
		const attachment = new store.model.Attachment({
			name: currentImgName,
			filename: currentImage.name,
			thumbnail: thumbnail.alt,
		});

		console.log('============= before upload', currentImage, thumbnail);
		await attachment.save().then(res => {
			record[property].add(attachment.id);
			attachment.uploadFile('thumbnail', Compress.convertBase64ToFile(thumbnail.data, thumbnail.ext)).end();
			attachment.uploadFile('filename', currentImage).end((error, result) => handleEnd(error, result, attachment));
		});
	};

	const deleteImage = async image => {
		await record[property].findById(image.id).then(res => {
			res.deleteFile('filename');
		});
		await record[property].remove(image.id);
		dispatch({ type: finishUpload, images: images.filter(e => e.id !== image.id) });
	};

	const changeImg = async () => {
		if (currentImage.id) {
			await record[property].updateById(currentImage.id, { name: currentImgName });
			currentImage.name = currentImgName;
			dispatch({ type: finishUpload, images });
		} else {
			const attachment = await record[property].findById(editImg);
			await attachment.deleteFile('filename');
			await attachment.deleteFile('thumbnail');
			attachment.name = currentImgName;
			attachment.filename = currentImage.name;
			attachment.thumbnail = thumbnail.alt;
			await attachment.save();

			const newImgs = images.map(image => {
				if (image.id !== editImg) {
					return image;
				} else {
					return { id: image.id, name: currentImgName, fileImage: currentImage.preview };
				}
			});

			dispatch({ type: updateImg, images: newImgs });
			await attachment.uploadFile('thumbnail', Compress.convertBase64ToFile(thumbnail.data, thumbnail.ext)).end();
			await attachment
				.uploadFile('filename', currentImage)
				.end((error, result) => handleEnd(error, result, attachment, newImgs));
		}
	};

	const onDrop = async file => {
		console.log('droped file', file);
		const thumbnail = await compress
			.compress(file, {
				size: 4, // the max size in MB, defaults to 2MB
				quality: 0.75, // the quality of the image, max is 1,
				maxWidth: 1920, // the max width of the output image, defaults to 1920px
				maxHeight: 1920, // the max height of the output image, defaults to 1920px
				resize: true, // defaults to true, set false if you do not want to resize the image width and height
			})
			.then(results => {
				return results[0];
			});

		console.log('thumbnail', thumbnail);
		dispatch({ type: setCurrentImage, image: file[0], thumbnail });
	};

	const renderImagePreview = () => {
		const { id } = currentImage;
		const img = id ? record.imported ? '/api/containers/attachments/download/'+currentImage.filename : currentImage.fileImage : currentImage.preview;
		console.log('==== current image', currentImage);
		const submit = () => {
			if (editImg) {
				return changeImg();
			}
			return imageUploader();
		};

		return (
			<Popup
				onClose={() => {
					dispatch({ type: finishUpload, images });
				}}
			>
				<div className="form__imagePreview">
					<Dropzone onDrop={onDrop} className="drop-zone" accept="image/jpeg, image/png">
						<img className="form__currentImage" src={img} alt={img} />
					</Dropzone>
					<input
						className="ui-input text-input form__currentImage-title"
						placeholder="Подпись"
						value={currentImgName}
						onChange={e => dispatch({ type: setImgName, name: e.target.value })}
						onKeyDown={e => e.keyCode === 13 && submit()}
					/>
					<Button className="btn-primary" style={{ marginRight: '1rem' }} label="Сохранить" onClick={() => submit()} />
					<Button label="Отмена" onClick={() => dispatch({ type: finishUpload, images })} />
				</div>
			</Popup>
		);
	};

	const renderImages = () => {
		return (
			<>
				{images.map(image => {
					// const fileImage = image.downloadFile('filename');

					// const name = image.name ? image.name : '';
					const { id, name, thumbnail } = image;
					return (
						<div key={`image-${id}`} className="form__image">
							<img
								src={record.imported ? '/api/containers/attachments/download/' + image.filename : thumbnail}
								alt={record.name}
								className="form__image-item"
								onClick={() => {
									dispatch({ type: onImgCLick, image, name, editImg: image.id });
								}}
							/>
							<Icon className="delete-file-btn form__image-icon" icon="trash" onClick={() => deleteImage(image)} />
							<p>{name}</p>
						</div>
					);
				})}
			</>
		);
	};

	// console.log('================ rendering images', record);
	return (
		<>
			<div className="form__images">
				{currentImage && renderImagePreview()}
				{images && !record.imported && (
					<Dropzone onDrop={onDrop} className="form__drop-zone" accept="image/jpeg, image/png">
						{!currentImage && <Button className="btn-primary" type="button" label="Добавить изображения" />}
					</Dropzone>
				)}
				<h3>Добавленные изображения</h3>
				<div className="form__imagesList">
					{images ? renderImages() : <p>Создайте запись, чтобы добавить изображения </p>}
				</div>
			</div>
		</>
	);
};
